export default __webpack_public_path__ + "static/media/ic_blog.ad102dbe.svg";